"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tag = exports.TagType = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Tag_style_1 = require("./Tag.style");
var TagType;
(function (TagType) {
    TagType["error"] = "error";
    TagType["information"] = "information";
    TagType["success"] = "success";
    TagType["warning"] = "warning";
    TagType["marketing"] = "marketing";
})(TagType = exports.TagType || (exports.TagType = {}));
var Tag = function (_a) {
    var children = _a.children, size = _a.size, type = _a.type, name = _a.name;
    var classes = (0, Tag_style_1.useTagStyles)();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "".concat(classes.tagContainer, " ").concat(classes[type], " ").concat(classes[size]), "data-signa": name }, children)));
};
exports.Tag = Tag;
